import { setLoading } from '../setLoading'
import { setFilteredFields } from '../setFilteredFields'
import { VehiclPartsFilterApi } from '../../api'

export const fetchFilteredFields = ({ group, payload }) => async (dispatch, getState) => {
  try {
    dispatch(setLoading(true))

    const api = new VehiclPartsFilterApi()
    const filteredFields = await api.getFilteredFields({ group, payload })

    if (filteredFields) dispatch(setFilteredFields(filteredFields))
    else dispatch(setFilteredFields(null))

    dispatch(setLoading(false))
  } catch (e) {
    dispatch(setFilteredFields(null))
    dispatch(setLoading(false))
  }
}
